const prices = [
	// {
	// 	title: 'Peněženka',
	// 	price: '7000',
	// 	perProject: true,
	// 	features: [
	// 		'Zasílání notifikací',
	// 		'Vizitka e-shopu v telefonu',
	// 		'Design vizitky na míru',
	// 	],
	// },
	{
		title: 'Startovní',
		price: '27 000',
		perProject: false,
		features: [
			'Zasílání notifikací',
			'Design aplikace dle webu',
			'Základní analytika',
			'Garance vracení peněz do 7 dnů',
		],
	},
	{
		title: 'Kompletní',
		price: '37 000',
		perProject: false,
		features: [
			'Plánování a zasílání notifikací',
			'Design aplikace na míru',
			'Pokročila analytika, sběr e-mailů',
			'Garance vracení peněz do 14 dnů',
		],
	},
	{
		title: 'Na míru',
		price: 'Na dotaz',
		perProject: true,
		features: [
			'Aplikace zcela na míru',
			'Individuální řešení',
			'Neomezené možnosti',
			'Garance pevné ceny',
		],
	},
]

const Pricing = () => {
	return (
		<div
			className="space-y-6 rounded-2xl bg-[#EEFFFE] pb-44 pt-20"
			id="pricing"
		>
			<h2 className="mb-16 text-center text-4xl font-extrabold">
				Vlastní aplikace stojí méně než si myslíte
			</h2>
			<div className="mx-10 grid grid-rows-4 gap-[31px] md:mx-16 lg:grid-cols-4 lg:grid-rows-1">
				<div className="relative">
					<div className="absolute -top-10 w-full">
						<PreparingFlag />
					</div>
					<PreparingPriceBox
						title="Peněženka"
						price="7000"
						features={[
							'Zasílání notifikací',
							'Vizitka e-shopu v telefonu',
							'Design vizitky na míru',
							'Garance vracení peněz do 14 dnů',
						]}
					/>
				</div>
				{prices.map(price => (
					<PriceBox
						key={price.title}
						title={price.title}
						price={price.price}
						features={price.features}
						perProject={price.perProject}
					/>
				))}
			</div>
			<p className="mt-8 text-center text-xl font-bold text-secondary ">
				Správa aplikace od 2 000 Kč/měsíc
			</p>
		</div>
	)
}

const PreparingFlag = () => {
	return (
		<div className="flex min-w-[288] justify-center gap-2 rounded-t-2xl bg-primary p-2 text-white">
			<img src="img/icons/clock.svg" alt="clock" />
			<b>Chystá se</b>
		</div>
	)
}

const PriceBox = ({
	title,
	price,
	features,
	perProject,
}: {
	title: string
	price: string
	features: string[]
	perProject?: boolean
}) => {
	return (
		<div className="flex h-full min-w-[288] flex-col items-center gap-6 rounded-2xl bg-secondary p-8 text-white">
			<p className="text-xl font-bold">{title}</p>
			<div className="text-center">
				<p className="text-3xl font-bold">{price} Kč</p>
				<p className="text-xs">{perProject ? 'za projekt' : 'za aplikaci'}</p>
			</div>
			<div className="flex flex-col gap-2">
				{features.map(feature => (
					<div key={feature} className="flex gap-5">
						<img src="img/icons/pricing-tick.svg" alt="tick" />
						<p>{feature}</p>{' '}
					</div>
				))}
			</div>
		</div>
	)
}
const PreparingPriceBox = ({
	title,
	price,
	features,
	perProject,
}: {
	title: string
	price: string
	features: string[]
	perProject?: boolean
}) => {
	return (
		<div className="flex h-full min-w-[288] flex-col items-center gap-6 rounded-b-2xl bg-secondary p-8 text-white">
			<p className="text-xl font-bold">{title}</p>
			<div className="text-center">
				<p className="text-3xl font-bold">{price} Kč</p>
				<p className="text-xs">{perProject ? 'za projekt' : 'za aplikaci'}</p>
			</div>
			<div className="flex flex-col gap-2">
				{features.map(feature => (
					<div key={feature} className="flex gap-5">
						<img src="img/icons/pricing-tick.svg" alt="tick" />
						<p>{feature}</p>{' '}
					</div>
				))}
			</div>
		</div>
	)
}
export default Pricing
